import ValidaTexto from '../../validadores/ValidaTexto';
import ValidaEmail from '../../validadores/ValidaEmail';
import { isValidPhoneNumber } from 'react-phone-number-input';

export default class ValidaContato {
    
    static valida(identificado,contato) {

        return new Promise((resolve,reject) => {
            try {
                let nome = ""
                let telefone = ""
                if (identificado) {
                    nome = validaNome(identificado,contato.nome);
                    telefone = validarTelefone(identificado,contato.telefone);
                }

                const email = validarEmail(identificado,contato.email);
                resolve({ nome, telefone, email })
            } 
            catch (msgErro) {
                reject(msgErro)
            }
        })
    }
}

const validaNome = (identificado,_nome) => {
    const nome = ValidaTexto.valida(_nome, 'Nome', !identificado, 128)
    const partes = nome.split(' ');
    if (partes.length === 1) {
        throw obterMsgErro("Digite seu nome completo!");
    }

    return nome.trim();
}

const obterMsgErro = msgErro => {
    return ({ status:400, tipo:'problema', texto:msgErro });
}

const validarTelefone = (identificado,_telefone) => {
    const telefone = ValidaTexto.valida(_telefone, 'Telefone', !identificado, 128);
    if (telefone.length === 0) {
        return telefone;
    }
    
    if (!isValidPhoneNumber(telefone)) {
        throw obterMsgErro("Número de telefone inválido!");
    }

    return telefone;
}

const validarEmail = (identificado,_email) => {
    const email = ValidaTexto.valida(_email, 'E-mail', !identificado, 254);
    if (email.length === 0) {
        return '';
    }

    const resposta = ValidaEmail.valida(email);
    return resposta.email;
}